export default __webpack_public_path__ + "static/media/pouf1.028a08ca.JPG";